import React from "react";
import { FaUsers } from 'react-icons/fa'
import { HiOutlineSwitchVertical } from 'react-icons/hi'

export default function Patients({patients}) {

    return (
        <div className="w-80 h-40 shadow-sm rounded-2xl bg-primary p-6">
            <div className="flex justify-between items-center mb-10 ">
                <div className="font-DM-Reg text-xl text-white">
                    <p>All Checked-in Patients</p>
                </div>
                <div>
                    <FaUsers
                        size="28px"
                        className="text-white"
                    />
                </div>
            </div>
            <div className="flex justify-between items-center my-10 ">
                <div className="font-pop-reg text-4xl text-white">
                    <p>{patients}</p>
                </div>
                <div className="flex justify-center items-center ">
                   
                </div>
            </div>
        </div>
    )
}